import { render } from "./RulesTable.vue?vue&type=template&id=7d4d7d6c&scoped=true"
import script from "./RulesTable.vue?vue&type=script&lang=js"
export * from "./RulesTable.vue?vue&type=script&lang=js"

import "./RulesTable.vue?vue&type=style&index=0&id=7d4d7d6c&lang=scss&scoped=true"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4d7d6c"]])

export default __exports__